import { Modal } from "antd";
import axios from "axios";
import AuthService from "./authService";
import storage from "redux-persist/lib/storage";
import Cookies from "js-cookie";

let lastErrorDisplayed = null;

const handleToken = async (config) => {
  const user = await AuthService.getUser();
  if (user && user.access_token) {
    config.headers["Authorization"] = `Bearer ${user.access_token}`;
  }
};
const handleAdditionalHeaders = (config) => {
  const pwa = window.matchMedia("(display-mode: standalone)").matches;
  const twa = localStorage.getItem("isTwa");

  config.headers["Device-Token"] = localStorage.getItem("fcmToken");
  config.headers["Accept-Language"] = localStorage.getItem("i18nextLng");
  config.headers["Application-Name"] = "FIROUZEHAPP";
  config.headers["Platform"] = twa ? "TWA" : pwa ? "PWA" : "WEB";
  config.headers["Application-Version"] = Cookies.get("version");
};

const handle401Error = async (instance, originalRequest) => {
  try {
    const refreshedUser = await AuthService.refreshToken();

    if (refreshedUser?.access_token) {
      instance.defaults.headers.common["Authorization"] = `Bearer ${refreshedUser.access_token}`;
      originalRequest.headers["Authorization"] = `Bearer ${refreshedUser.access_token}`;
      return instance(originalRequest);
    }
  } catch (error) {
    window.location.href = "/";
    localStorage.clear();
    storage.removeItem("persist:root");
  }
};

const handleBlobError = async (error) => {
  if (error.response && error.response.data) {
    const reader = new FileReader();
    reader.onloadend = () => {
      try {
        const errorMessage = JSON.parse(reader.result);
        return Modal.error({
          title: "خطا",
          content: errorMessage?.detail,
          okText: "تایید",
          centered: true,
        });
      } catch (e) {
        console.error("Error parsing blob response:", e);
      }
    };
    reader.readAsText(error.response.data);
    return;
  }
};

const handleError = (error, showErrorsAlways) => {
  const errorMessage =
    error?.response?.data?.message ||
    (error?.response?.data?.detail &&
      error?.response?.data?.detail[0] &&
      error?.response?.data?.detail[0]?.msg) ||
    error?.response?.data?.detail ||
    error?.response?.data ||
    "خطایی رخ داده است. دوباره تلاش کنید";

  if (showErrorsAlways) {
    lastErrorDisplayed = null;
  }
  // Check if the error message is the same as the last displayed error
  if (errorMessage !== lastErrorDisplayed) {
    lastErrorDisplayed = errorMessage; // Update the last displayed error
    return Modal.error({
      title: "خطا",
      content: errorMessage,
      okText: "تایید",
      centered: true,
    });
  }

  return null;
};

const handleErrorStatus = (error) => {
  return (
    error.response?.status !== 403 &&
    error.response?.status !== 401 &&
    error?.response?.data?.detail !== "ONB-REQUIRED" &&
    error?.response?.data?.detail !== "LIMIT_AMOUNT" &&
    !error?.config?.url.includes("referral/activate") &&
    !error?.config?.url.includes("inquiry-destination/CARD") &&
    !error?.config?.url.includes(
      "recommendation/api/v1/last-complete-survey"
    ) &&
    !error?.config?.url.includes("prize/api/v1/voucher/redeem/")
  );
};

const handleErrorException = (error) => {
  return (
    error?.config?.url.includes("referral/activate") ||
    error?.response?.data?.detail === "LIMIT_AMOUNT" ||
    error?.config?.url.includes("inquiry-destination/CARD") ||
    error?.config?.url.includes("inquiry-destination/IBAN") ||
    error?.config?.url.includes("recommendation/api/v1/last-complete-survey") ||
    error?.config?.url.includes("prize/api/v1/voucher/redeem")
  );
};

const apiCall = (handleONB, options) => {
  const { showErrorsAlways = false } = options ?? {};

  const instance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_SERVER,
    headers: {},
    contentType: "application/json-patch+json",
    responseType: "json",
  });

  instance.interceptors.request.use(
    async (config) => {
      await handleToken(config);
      handleAdditionalHeaders(config);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      // handleApiSuccessResponse(response);
      return response;
    },
    (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        return handle401Error(instance, originalRequest);
      }
      if (error.config?.responseType === "blob") {
        return handleBlobError(error);
      }
      if (handleErrorStatus(error)) {
        return handleError(error, showErrorsAlways);
      }
      if (error?.response?.data?.detail === "ONB-REQUIRED") {
        return handleONB();
      }
      if (handleErrorException(error)) {
        return error;
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default apiCall;
